/**
 * @format
 * @module bundles/election
 * @description The bundle for the election results page
 */
import crow from "utils/crow";
import initElectionService, { initElectionRefresh } from "lib/election/service";
import { initElectionBubbleChart } from "lib/election/bubble-chart";
import { initElectionLiveResults } from "lib/election/live-results";
import initElectionLiveResultsTable from "lib/election/live-results-table";
import initElectionMap from "lib/election/election-map";
import { initElectionPartyLeaders } from "lib/election/party-leaders";
import initSwitchingHands from "lib/election/switching-hands";
import initElectionRidingCards from "lib/election/riding-cards";

/**
 * @method init
 * @description Setup the election page.
 */
function init() {
  initElectionService();
  initElectionLiveResults();
  // initElectionRefresh should be placed after live results feature so the refresh checkbox is there
  initElectionRefresh();
  initElectionLiveResultsTable();
  initElectionBubbleChart();
  initElectionMap();
  initElectionPartyLeaders();
  initSwitchingHands();
  initElectionRidingCards();
}

crow.context(
  {
    feature: "bundle : election"
  },
  init
);
